import { jsx as p } from "react/jsx-runtime";
import { c as s } from "react/compiler-runtime";
import { Box as f } from "@mui/material";
import { forwardRef as l } from "react";
const a = l((m, i) => {
  const o = s(7);
  let r, t;
  o[0] !== m ? ({
    children: r,
    ...t
  } = m, o[0] = m, o[1] = r, o[2] = t) : (r = o[1], t = o[2]);
  let e;
  return o[3] !== r || o[4] !== t || o[5] !== i ? (e = /* @__PURE__ */ p(f, { ref: i, ...t, children: r }), o[3] = r, o[4] = t, o[5] = i, o[6] = e) : e = o[6], e;
});
export {
  a as Box
};
